var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardRocketIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.261,
    height: 33.261,
    viewBox: "0 0 33.261 33.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_83781",
    x: 2.725,
    y: 7.433,
    width: 23.103,
    height: 23.103,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9516f3",
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_83782",
    x: 0,
    y: 0,
    width: 24.623,
    height: 23.229,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8516f3",
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_83783",
    x: 10.032,
    y: 8.638,
    width: 23.229,
    height: 24.623,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6b16f3",
    floodOpacity: 0.424
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket_duo",
    transform: "translate(9 2.614)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -2.61)",
    filter: "url(#Path_83781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83781-2",
    "data-name": "Path 83781",
    d: "M36.331,113.453a.976.976,0,0,1-.667.987L31.873,115.7a.489.489,0,0,1-.618-.618l1.264-3.791a.975.975,0,0,1,.987-.667Z",
    transform: "translate(-19.5 -97.19)",
    fill: "#a881e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -2.61)",
    filter: "url(#Path_83782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83782-2",
    "data-name": "Path 83782",
    d: "M8.512,42.823l.117-1.4,1.944-3.127.5-.693c-.342-.009-.711,0-1.1.023a6.178,6.178,0,0,0-5.1,2.743l-.432.72Z",
    transform: "translate(4.55 -31.59)",
    fill: "#a881e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -2.61)",
    filter: "url(#Path_83783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83783-2",
    "data-name": "Path 83783",
    d: "M108.251,122.472c.009.342,0,.711-.023,1.1a6.178,6.178,0,0,1-2.743,5.1l-.72.432-1.739-4.058,1.4-.117,3.127-1.944Z",
    transform: "translate(-83.99 -107.83)",
    fill: "#a881e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83784",
    "data-name": "Path 83784",
    d: "M62.224,17.489l-3.946-3.946L58.407,12l1.729-2.782.98-1.348L63.55,5.582a4.639,4.639,0,0,1,3.538-1.249l2.575.2A1.709,1.709,0,0,1,71.237,6.1l.2,2.575q.009.122.012.244a4.641,4.641,0,0,1-1.261,3.294l-2.293,2.434-1.348.98-2.782,1.729ZM68.053,9.8a1.466,1.466,0,1,1,0-2.073A1.466,1.466,0,0,1,68.053,9.8Z",
    transform: "translate(-52.801 -4.32)",
    fill: "#cdbef8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRocketIcon);
export default __webpack_public_path__ + "static/media/dashboard-rocket-icon.60582433c98895b31a54599c1bc82221.svg";
export { ForwardRef as ReactComponent };